module Omni.ResortMap {
    ngModule.filter('naFilter', function () {
            return function (input) {
                if (input == 0) {
                    return "NA";
                } else {
                    return input;
                }
            };
        })
        .filter('ftFilter', function () {
            return function (input) {
                if (!isNaN(input) && input !== 0) {
                    return input + "'";
                } else {
                    return input;
                }
            };
        });
}
